import HttpStatus from 'components/Common/HttpStatus'
import Error404Page from 'components/Pages/Error404Page'
import { Route } from 'react-router'
import loadable from '@loadable/component'
import LocaleAwareSwitch from 'components/App/Routes/LocaleAwareSwitch'
import { LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP, LE_AGENT_HUB_SOCIETE_CONFIRMATION } from './AgentHubRoutes'
import AuthRoute from 'components/App/Routes/AuthRoute'

const AgentHubLandingPage = loadable(() => import('agentHub/pages/landing/AgentHubLandingPage'))
const AgentHubCompleteAccountSetup = loadable(() => import('agentHub/pages/AgentHubAccountSetup/AgentHubCompleteAccountSetupPage'))
const SocieteConfirmationPage = loadable(() => import('agentHub/pages/SocieteConfirmationPage'))
const ResetPasswordPage = loadable(() => import('components/Pages/ResetPasswordPage/ResetPasswordPage'))

function AgentHubGuestPageRoutes() {
  return <LocaleAwareSwitch>
    <Route path="/:regionCode">
      <LocaleAwareSwitch>
        <Route exact path="/:regionCode" component={AgentHubLandingPage} />
        <Route exact path={`/:regionCode${LE_AGENT_HUB_COMPLETE_ACCOUNT_SETUP}`} component={AgentHubCompleteAccountSetup} />
        <Route exact path={`/:regionCode${LE_AGENT_HUB_SOCIETE_CONFIRMATION}`} component={SocieteConfirmationPage} />
        <Route exact path="/:regionCode/reset-password/:resetPasswordToken" component={ResetPasswordPage} />

        {/**
         * All other page paths are behind a login wall
         * So if a user tries to access anything, make them login instead
         */}
        <AuthRoute showPopup />
      </LocaleAwareSwitch>
    </Route>
    {/*
      Code below will match all non-declared routes
      It will also stop all routes loaded after it from rendering
      if your route isn't rendering on agent hub, make sure it
      is loaded before this component
    */}
    <Route>
      <HttpStatus code={404}>
        <Error404Page />
      </HttpStatus>
    </Route>
  </LocaleAwareSwitch>
}

export default AgentHubGuestPageRoutes
